import cx from "classnames";
import React from "react";

import styles from "./LineHeader.mscss";

interface OwnProps {
    className?: string;
    heading?: string;
    count?: number;
    level?: number;
}

type Props = OwnProps;

export const LineHeader: React.StatelessComponent<Props> = ({
    className,
    heading,
    count,
    children,
    level,
}) => {
    const head = heading ? (
        <h1 className={styles.LineHeader__heading}>
            {heading}
            {count !== undefined && <span className={styles.LineHeader__count}> ({count})</span>}
        </h1>
    ) : null;

    let left = null;
    let right = null;

    if (children) {
        React.Children.forEach(children, (child) => {
            if (!React.isValidElement<{ children: React.ReactChildren }>(child)) {
                return;
            }

            if (typeof child.type === "string" || (child.type !== Left && child.type !== Right)) {
                throw new Error(
                    `Component "LineHeader" only accepts children of type "<Left>" and "<Right>", not "${child.type}".`,
                );
            }

            if (child.type === Left) {
                left = child.props.children;
            } else if (child.type === Right) {
                right = child.props.children;
            }
        });
    }

    return (
        <div
            className={cx(
                styles.LineHeader,
                className,
                level && styles[`LineHeader--level${level}`],
            )}
        >
            {(head || left) && (
                <div
                    className={cx(styles.LineHeader__content, styles["LineHeader__content--left"])}
                >
                    {head}
                    {left}
                </div>
            )}
            <div className={styles.LineHeader__line} />
            {right && (
                <div
                    className={cx(styles.LineHeader__content, styles["LineHeader__content--right"])}
                >
                    {right}
                </div>
            )}
        </div>
    );
};

LineHeader.displayName = "LineHeader";

export const Right: React.StatelessComponent<{}> = ({ children }) => <span>{children}</span>;
export const Left: React.StatelessComponent<{}> = ({ children }) => <span>{children}</span>;
